<h1 class="title-sect color-blue-dark font-30 f-31">
  Ajustes en documentos de subsidio y/o afiliación
</h1>
<div class="card shadow-item bg-white mg-btm-60 over-hiden col-xs-12">
  <h3 class="subtitle-sect color-blue-dark font-24 f-32">
    Corrigue los documentos con novedades de tus Beneficiario.
  </h3>
    <div class="m-t-50">
        <div class="container">
          <div class="form-section container">
            <div class="container-form">
              <div>
                <div class="info-titular bg-light-blue p-4 rounded-lg shadow-item mb-4">
                  <h2 class="color-blue-dark font-24 mb-2">Información de la solicitud</h2>
                  <p class="color-gray font-16">
                    <strong>Radicado:</strong> {{ data?.code || 'No registrada' }}
                  </p>
                  <p class="color-gray font-16">
                    <strong>Fecha de radicacion:</strong> {{ data?.update_at | date:'dd/MM/yyyy h:mm a' }}
                  </p>
                </div>

                <div class="info-titular bg-light-blue p-4 rounded-lg shadow-item mb-4">
                  <h2 class="color-blue-dark font-24 mb-2">Información del Titular</h2>
                  <p class="color-gray font-16">
                    <strong>Nombre:</strong> {{nombreTitular}}
                  </p>
                  <p class="color-gray font-16">
                    <strong>Número de Documento:</strong> {{ data?.numberDocument}}
                  </p>
                </div>

                <div class="alert-message mb-4">
                  <p class="alert-text text-warning text-center">
                    ¡Atención! Recuerde que tiene un plazo máximo de 5 días para cargar los documentos solicitados a continuación.
                  </p>
                </div>
                <mat-accordion >
                  <ng-container *ngFor="let key of objectKeys(data?.documentos); let i = index">
                  <mat-expansion-panel *ngIf="panelVisibility[i]">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <strong>Documento:</strong>&nbsp;{{ data?.documentos[key].documentos[0].documento.numeroIdentidadPropietarioDocumento }} 
                        - 
                        &nbsp;<strong>Beneficiario:</strong>&nbsp;{{ data?.documentos[key].documentos[0].nombreCompleto }}
                      </mat-panel-title>
                      
                    </mat-expansion-panel-header>
                    <table aria-label="Tabla de histórico de afiliaciones" class="rwd-table" width="100%" height="100%" cellpadding="0" cellspacing="0" id="tableAffiliation">
                      <thead class="thead">
                        <th  scope = "col" class="text-gray-category color-gray">
                          tipo complemento
                        </th>
                        <th  scope = "col" class="text-gray-category color-gray">
                          nombre/archivo
                        </th>
                    
                        <th  scope = "col" class="text-gray-category color-gray">
                          comentario
                        </th>
                    
                        <th  scope = "col" class="text-gray-category color-gray">
                          Fecha revision
                        </th>
                    
                        <th  scope = "col" class="text-gray-category color-gray">
                          Gestion
                        </th>
                      </thead>
                    
                      <div class="row mt-masive" *ngIf="loadingTop">
                        <div class="col-md-12 text-center">
                          <div class="spinner-two spinner-two-blue"></div>
                        </div>
                      </div>
                    
                      <tbody>
                    
                        <tr *ngIf="data?.documentos.length <= 0 && !loadingTop">
                          <td colspan="5" style="text-align: center;">
                            <span class="text-gray-category color-red">No hay documentos recientes</span>
                          </td>
                        </tr>
                        
                        <tr *ngFor="let documento of data?.documentos[key].documentos">
                          <td data-th="tipo complemento">
                            <div>
                              {{ documento?.documento.solicitudesComplementosEntity.solicitudesTipos.tipo }}
                            </div>
                          </td>
                        
                          <td data-th="nombre/archivo">
                            <div class="texto-recortado">
                              <a 
                                [href]="getBlobUrl(documento?.documento.url)" 
                                target="_blank" 
                                rel="noopener noreferrer"
                              >
                                {{ documento?.documento.documentosDigitalesTipos.nombre }}
                              </a>
                            </div>
                          </td>
                        
                          <td data-th="comentario">
                            <div>
                              {{ documento?.documento.observaciones}}
                            </div>
                          </td>
                        
                          <td data-th="Fecha revision">
                            <div>
                              {{ documento?.documento.fechaActualizacion | date:'dd/MM/yyyy h:mm a' }}
                            </div>
                          </td>
                        
                          <td data-th="Gestión" class="text-gray-category color-gray">
                            <input 
                              type="file" 
                              #fileInput 
                              (change)="onFileSelected($event, documento, key, i)" 
                              accept="application/pdf" 
                              style="display: none;"
                            />
                            
                            <button 
                              *ngIf="!documento.selectedFile" 
                              (click)="fileInput.value = null; fileInput.click()" 
                              class="u-btn u-btn--blue"
                            >
                              Seleccionar Archivo
                            </button>
                          
                            <button 
                              *ngIf="documento?.selectedFile" 
                              (click)="removeFile(documento, fileInput, key, i)" 
                              class="u-btn u-btn--red u-btn--delete"
                            >
                              Eliminar Archivo
                            </button>
                          </td>
                        </tr>
                        
                        <div class="h-35"></div>
                      </tbody>
                    </table> 
                    <div class="col-md-12">
                      <div class="steps-cont_actions d-flex justify-content-center container">
                        <button
                          role="button"
                          appDebounceClick
                          id="Afiliacion_PTEC-afiliar-trabajador-regresar"
                          title="Enviar todos los documentos"
                          (click)="enviarTodosDocumentos(i, key)"  
                          [disabled]="!allDocumentsUploaded[i]"
                          class="u-btn u-btn--blue"
                        >
                          Enviar
                        </button>
                      </div>
                    </div>
                    
                  </mat-expansion-panel>
                </ng-container>
                </mat-accordion>
              </div>
            </div>
            <br />
            
          </div>
  
          <div class="col-md-12">
            <div
              class="steps-cont_actions d-flex justify-content-center container"
            >

              <a
                role="button"
                appDebounceClick
                id="Afiliacion_PTEC-afiliar-trabajador-regresar"
                title="Volver"
                href="javascript:history.back()"
                routerLinkActive="router-link-active"
                class="u-btn u-btn--line r-hide"
                >Volver
              </a>
            </div>
          </div>
        </div>
    </div>
</div>
